import React, { useEffect, useState } from 'react';
import { DashboardContainer, DashboardContent, DashboardHeader, DashboardTitle, DashboardActions } from './styles';
import { BackButton } from '../Settings/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Card } from './Card';
import { Chart } from './Chart';
import { NegotiatorTable } from './NegotiatorTable';
import { useDashboard } from './hooks/useDashboard';
import LoadingCenterDiv from 'newComponents/LoadingCenterDiv';
import { DashboardDateRange } from 'newComponents/DashboardDateRange';

export const Dashboard = () => {
	const getDefaultDateRange = () => {
		const today = new Date();
		const firstDayOfMonth = new Date( today.getFullYear(), today.getMonth(), 1 );
		return {
			startDate : firstDayOfMonth,
			endDate   : today
		};
	};

	const [ dateRange, setDateRange ] = useState( getDefaultDateRange() );
	
	const { 
		negotiationDashboard, 
		getNegotiationDashboard, 
		isLoading, 
		allNegotiators, 
		selectedNegotiators, 
		handleNegotiatorFilterChange,
		paginatedNegotiators,
		currentPage,
		totalPages,
		handlePageChange,
		itemsPerPage,
		sortConfig,
		handleSortChange
	} = useDashboard();

	const handleDateRangeChange = ( value ) => {
		// value é um array [startDate, endDate] ou null
		const startDate = value ? value[0] : null;
		const endDate = value ? value[1] : null;
		
		setDateRange( { startDate, endDate } );
		
		// Chamar getNegotiationDashboard com as novas datas
		const dateFilter = ( startDate && endDate ) ? { startDate, endDate } : null;
		getNegotiationDashboard( dateFilter );
	};

	useEffect( () => {
		const initialDateFilter = {
			startDate : dateRange.startDate,
			endDate   : dateRange.endDate
		};
		getNegotiationDashboard( initialDateFilter );
	}, [] ); //eslint-disable-line

	if ( isLoading ) {
		return (
			<DashboardContainer>
				<DashboardHeader>
					<BackButton>
						<ArrowBackIcon />
					</BackButton>
					<DashboardTitle>Dashboard controle</DashboardTitle>
				</DashboardHeader>
				<LoadingCenterDiv title={'Carregando...'} />
			</DashboardContainer>
		);
	}

	return (
		<DashboardContainer>
			<DashboardHeader>
				<BackButton>
					<ArrowBackIcon />
				</BackButton>
				<DashboardTitle>Dashboard controle</DashboardTitle>
			</DashboardHeader>
			<DashboardActions>
				<div style={{ backgroundColor: 'white', padding: '8px', borderRadius: '8px' }}>
					<DashboardDateRange
						value={dateRange.startDate && dateRange.endDate ? [ dateRange.startDate, dateRange.endDate ] : null}
						onChange={handleDateRangeChange}
						label="Período"
					/>
				</div>
			</DashboardActions>
			<DashboardContent>
				<div className='CardSection'>
					<span style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>Métricas IA</span>
					<div className='CardList'>
						{negotiationDashboard?.IaKeys?.map( ( key ) => (
							<Card key={key}	 item={key} value={negotiationDashboard?.data[key]} />
						) )}
					</div>
					<span style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>Métricas Negociadores</span>
					<div className='CardList'>
						{negotiationDashboard?.negotiatorsKeys?.map( ( key ) => (
							<Card key={key}	 item={key} value={negotiationDashboard?.data[key]} />
						) )}
					</div>
				</div>
				
				<Chart 
					dashboardData={negotiationDashboard?.data}
					negotiatorsData={allNegotiators}
				/>
				
				<div className='NegotiatorSection'>
					<NegotiatorTable 
						data={paginatedNegotiators}
						allNegotiators={allNegotiators}
						selectedNegotiators={selectedNegotiators}
						onFilterChange={handleNegotiatorFilterChange}
						currentPage={currentPage}
						totalPages={totalPages}
						onPageChange={handlePageChange}
						itemsPerPage={itemsPerPage}
						totalItems={negotiationDashboard?.negotiatorsTable?.length || 0}
						sortConfig={sortConfig}
						onSortChange={handleSortChange}
					/>
				</div>
			</DashboardContent>
		</DashboardContainer>
	);
};